import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.starts-with.js";
import base from "./production.js";
import { lib } from '@giscube/geoportal';
var GiscubeRef = lib.refs.GiscubeRef;
export var jocsinfantilsId = new GiscubeRef('25.4');
export default base.merge({
  branding: {
    header: {
      logo: require('assets/logo_ajfigueres-negre.svg'),
      text: 'Jocs infantils a Figueres',
      link: null
    }
  },
  capabilities: {
    login: true
  },
  databaseLayers: {
    config: {
      'ajfigueres': {
        'jocs_infantils': {
          preload: true,
          active: true,
          elementCodeField: 'codi',
          elementTypeTitle: 'Joc infantil',
          title: 'Jocs infantils',
          // Giscube
          wmsId: jocsinfantilsId,
          wmsLayers: ['Jocs infantils']
        },
        'jocs_infantils_tancats': {
          preload: false,
          active: true,
          elementCodeField: 'id',
          elementTypeTitle: 'Tancat',
          title: 'Tancats',
          // Giscube
          wmsId: jocsinfantilsId,
          wmsLayers: ['Tancat']
        },
        'jocs_infantils_vordures': {
          preload: false,
          active: true,
          elementCodeField: 'id',
          elementTypeTitle: 'Vordura',
          title: 'Vordures',
          // Giscube
          wmsId: jocsinfantilsId,
          wmsLayers: ['Vordures']
        },
        'jocs_infantils_paviments': {
          preload: false,
          active: true,
          elementCodeField: 'id',
          elementTypeTitle: 'Paviment',
          title: 'Paviments',
          // Giscube
          wmsId: jocsinfantilsId,
          wmsLayers: ['Paviments']
        },
        'jocs_infantils_arees': {
          preload: false,
          active: true,
          elementCodeField: 'id',
          elementTypeTitle: 'Àrea de joc infantil',
          title: 'Àrees de jocs infantils',
          // Giscube
          wmsId: jocsinfantilsId,
          wmsLayers: ['Arees de Joc']
        }
      }
    },
    layersFilter: function layersFilter(layers) {
      return layers.filter(function (layer) {
        return layer.name.startsWith('jocs_infantils');
      });
    }
  },
  defaultLayers: [{
    id: jocsinfantilsId,
    layerDescriptor: {
      url: 'https://parcsjardins.figueres.org:8088/apps/giscube-admin/qgisserver/services/jocs_infantils',
      type: 'WMS',
      title: 'Jocs infantils',
      layers: [{
        name: 'Jocs infantils',
        active: true
      }, {
        name: 'Vordures',
        active: true
      }, {
        name: 'Tancat',
        active: true
      }, {
        name: 'Arees de Joc',
        active: true
      }, {
        name: 'Paviments',
        active: true
      }],
      projection: '3857'
    },
    options: {
      maxZoom: 23
    },
    title: 'Jocs infantils'
  }],
  editsources: [{
    code: 'ajfigueres',
    name: 'Ajuntament de Figueres',
    url: 'https://parcsjardins.figueres.org:8088/apps/giscube-admin-api/'
  }],
  gesparc: {},
  layout: {
    components: {
      HomePanel: function HomePanel() {
        return require('components/jocsinfantils/HomePanel.vue').default;
      }
    },
    headerToolbar: ['home', 'search', 'catalog', 'streetview', 'data', 'draw', 'print', 'share', '----------', {
      icon: 'settings',
      label: 'altres',
      items: ['----------', 'fullscreen', '----------', 'contact', '----------', 'help']
    }, 'auth']
  },
  lifecycle: {
    app: {
      created: function created(_ref) {
        var root = _ref.root;
        return console.log('App created: jocs infantils');
      }
    }
  },
  modules: [],
  oauth: {
    type: 'password',
    client_id: 'Q9S6ipmHxZknlLwNi5N7z6VujbfhU98rZCCdRRIH',
    token: 'https://parcsjardins.figueres.org/apps/giscube-admin/o/token/',
    revokeToken: 'https://parcsjardins.figueres.org/apps/giscube-admin/o/revoke-token/'
  },
  sentry: {
    dsn: 'https://c4099e01986545d28693a8e401abdbb5@o249861.ingest.sentry.io/4504354067185664',
    console: {
      // array of methods that should be captured
      // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
      levels: ['error']
    }
  }
});